import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { Services } from './services';
import { MdePopoverModule } from '@material-extended/mde';
import { ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MdePopoverModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule
  ],
  exports: [
    MaterialModule,
    MdePopoverModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule
  ],
  declarations: [
  ],
  entryComponents: [
  ],
  providers: [
    ...Services,
    DatePipe
  ]
})
export class SharedModule { }
